const CUSTOMER_AI_TRUST_PRINCIPLES =
  "https://www.twilio.com/en-us/blog/customer-ai-trust-principles-privacy-framework";

const TWILIO_PRIVACY_NOTICE = "https://www.twilio.com/en-us/legal/privacy";

const constants = { CUSTOMER_AI_TRUST_PRINCIPLES, TWILIO_PRIVACY_NOTICE };

export default constants;
